module.exports = __webpack_public_path__ + "static/39FEA2_3_0-f2a81974c18484d0faa51dd7400c53e8.woff2";